import { useEffect } from 'react';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { CountryDropdown } from '../components/CountryDropdown';
import RequestTypeLabel from '../components/RequestTypeLabel';
import Recaptcha from '../components/Recaptcha';
import { LanguageSelect } from './locales/LanguageSelect';
import LocaleFormattedMessage from './locales/LocaleFormattedMessage';
import LocaleFormattedJSXMessage from './locales/LocaleFormattedJSXMessage';
import useMediaQuery, { MEDIA_QUERY_BREAKPOINTS } from '../hooks/use-media-query';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RequestForm({
  dataTestId,
  country,
  email,
  logoAltText,
  logoUrl,
  onChangeCountry,
  onChangeEmail,
  onChangeRecaptchaToken,
  onChangeRequestType,
  onSubmit,
  requestType,
  requestTypes,
  submitButtonDisabled,
  businessEmail,
  isRecaptchaEnabled,
  showCountrySetting
}) {
  const isMobile = useMediaQuery(MEDIA_QUERY_BREAKPOINTS.sm);
  useEffect(() => {
    if (requestTypes.length === 1) {
      onChangeRequestType(requestTypes[0]);
    }
  }, [onChangeRequestType, requestTypes]);
  return /*#__PURE__*/_jsx(TFlex, {
    "data-test-id": dataTestId,
    align: "center",
    direction: "column",
    backgroundColor: isMobile ? 'fill-surface-default' : 'border-core-subtle',
    minBlockSize: "100vh",
    children: /*#__PURE__*/_jsxs(View, {
      "data-test-id": "data-privacy-request-ui",
      marginBlock: isMobile ? '0' : '500',
      paddingInline: isMobile ? '600' : '1400',
      paddingBlock: isMobile ? '600' : '1000',
      backgroundColor: "fill-surface-default",
      borderRadius: "200",
      children: [logoUrl && /*#__PURE__*/_jsx(Image, {
        alt: logoAltText,
        src: logoUrl,
        marginBlockEnd: "100",
        maxInlineSize: "100px",
        maxBlockSize: "200px"
      }), /*#__PURE__*/_jsx(LanguageSelect, {}), /*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.dataPrivacyRequest"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.dataPrivacyRequestDescription"
        })
      }), showCountrySetting === 'ENABLED_AND_ENFORCED' && /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.country.title"
        }),
        required: true,
        children: /*#__PURE__*/_jsx(CountryDropdown, {
          value: country,
          onChange: onChangeCountry
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.requestTypeDescription"
        }),
        required: true,
        children: /*#__PURE__*/_jsx(ToggleGroup, {
          name: "request-type",
          children: requestTypes.map(_requestType => /*#__PURE__*/_jsx(RadioInput, {
            "data-test-id": `${_requestType}-radio`,
            onChange: () => onChangeRequestType(_requestType),
            checked: requestType === _requestType,
            children: /*#__PURE__*/_jsx(RequestTypeLabel, {
              requestType: _requestType
            })
          }, _requestType))
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.email"
        }),
        required: true,
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-test-id": "email-input",
          name: "email",
          value: email,
          onChange: e => onChangeEmail(e.target.value)
        })
      }), isRecaptchaEnabled && /*#__PURE__*/_jsx(Recaptcha, {
        onReceiveToken: onChangeRecaptchaToken
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "submit-button",
        use: "primary",
        onClick: onSubmit,
        disabled: submitButtonDisabled,
        marginBlockStart: "700",
        children: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
          message: "app.submit"
        })
      }), businessEmail && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        as: "div",
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(LocaleFormattedJSXMessage, {
            message: "app.emailContentWithLink_jsx",
            options: {
              email: businessEmail,
              href: `mailto:${businessEmail}`
            },
            elements: {
              Link
            }
          })
        })
      })]
    })
  });
}
export default RequestForm;